$(function () {
  let deploy_is_prod = false;

  let reg = /^(192.168.3.)/;
  if (window.location.hostname !== 'localhost' && !reg.test(window.location.hostname)) {
    deploy_is_prod = true;
  }

  if (deploy_is_prod) {
    // 判断非本地server时 http强制转换成https
    var targetProtocol = "https:";
    if (window.location.protocol != targetProtocol)
      window.location.href = targetProtocol +
        window.location.href.substring(window.location.protocol.length);
  }

  if (deploy_is_prod) {
    // 禁止查看源码
    document.onkeydown = function () {
      var e = window.event || ar || arguments[0];
      if (e.keyCode == 123) {
        return false;
      }
      else if ((e.ctrlKey) && (e.shiftKey) && (e.keyCode == 73)) {
        return false;
      }
      else if ((e.ctrlKey) && (e.keyCode == 85)) {
        return false;
      }
      else if ((e.ctrlKey) && (e.keyCode == 83)) {
        return false;
      }
      else if ((e.shiftKey) && (e.keyCode == 121)) {
        return false;
      }
    }
    
    document.oncontextmenu = function () {
      // alert("It's no use trying to open F12 from the context menu")
      return false;
    }

    var check_f12 = function () {
      function doCheck (a) {
        if (("" + a / a)["length"] !== 1 || a % 20 === 0) {
          (function () { }
          ["constructor"]("debugger")())
        } else {
          (function () { }
          ["constructor"]("debugger")())
        }
        doCheck(++a)
      }
      try {
        doCheck(0)
      } catch (err) { }
    };

    check_f12();
    setInterval(function () {
      check_f12()
    }, 2000);

  }
})